module.exports = __webpack_public_path__ + "static/media/pizza.838a8a41.png";